import React, { useState } from 'react';
import TextToSpeech from './components/TextToSpeech';

const App = () => {
    return (
      <TextToSpeech />
      // <div class="text-center card p-3">
      //   <p><strong>Discover the Perfect TikTok Voice for Your Videos!</strong><br />Want to create unique voiceovers for your TikTok content? Try the <strong>Unlimited Free Text to TikTok Voice Generator</strong> – a free tool that lets you easily convert text into TikTok-style voiceovers.<br /><strong>Click the link below to start creating now!</strong></p>
      //   <p><a href="https://www.unminifydev.com/tiktok-voice-generator/" rel="noopener"><strong>Access Now!</strong></a> or <a href="https://www.subeditpro.com/tiktok-voice-generator/" rel="noopener"><strong>Start Now!</strong></a></p>
      // </div>
    );
};

export default App;
